import { render } from "./OauthAuth.vue?vue&type=template&id=4b1a892c&scoped=true"
import script from "./OauthAuth.vue?vue&type=script&lang=js"
export * from "./OauthAuth.vue?vue&type=script&lang=js"

import "./OauthAuth.vue?vue&type=style&index=0&id=4b1a892c&lang=sass&scoped=true"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b1a892c"]])

export default __exports__